import React from 'react'
import { useTranslation } from 'react-i18next'

export type MultimediaLinkProps = {
  id?: string
  title?: string
  linkUrl?: string
  onClick: (id?: string) => void
}

const MultimediaLink: React.FC<MultimediaLinkProps> = ({ id, title, linkUrl, onClick }) => {
  const { t } = useTranslation()
  return linkUrl ? (
    <li>
      <span className='link-text' title={linkUrl} aria-label={title ? title : linkUrl}>
        {title ? title : linkUrl}
      </span>
      <span
        className='cursor-pointer align-right margin-s'
        onClick={() => onClick(id)}
        role='button'
        aria-label={t('wizard.screen.multimedia.linksManager.deleteLink', 'Delete link')}
      >
        <i className='is24-icon-delete' />
      </span>
    </li>
  ) : (
    <></>
  )
}

export default MultimediaLink
